import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { batukPartnerApi } from "../../app/slices/batukPartner/batukPartnerSlice";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import ToastComponent from "./../../components/customTable/ToastComponent";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";
export default function BatukPartner() {
  const token = localStorage.getItem("token");

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const roleResponse = useSelector((state) => state.login.login.role);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(batukPartnerApi());
  }, [dispatch]);
  const sliceResponse = useSelector(
    (state) => state.batukPartner.batukPartner.data,
  );
  const stateLoading = useSelector((state) => state.batukPartner.loading);
  // loading={stateLoading}
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("PartnerId", {
      header: "PartnerId",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.PartnerId}
        </div>
      ),
    }),
    columnHelper.accessor("commission", {
      header: "Commission Percentage",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.commission}
        </div>
      ),
    }),
    columnHelper.accessor("mmtc_commission", {
      header: "MMTC Commission Percentage",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.mmtc_commission}
        </div>
      ),
    }),
  ];

  // if (roleResponse?.BatukPartner?.update === 1) {
  //   columns.push(
  //     columnHelper.accessor("action", {
  //       header: "Action",
  //       size: 30,
  //       Cell: (cell) =>
  //         roleResponse?.BatukPartner?.update === 1 && (
  //           <>
  //             <Box sx={{ display: "flex", gap: 1 }}>
  //               <Box
  //               >
  //                 <Button
  //                   onClick={() => handleOpen(cell.row.original)}
  //                   variant="contained"
  //                   sx={{ borderRadius: "12px", fontSize: "10px" }}
  //                 >
  //                   Update commission
  //                 </Button>
  //               </Box>
  //             </Box>
  //           </>
  //         ),
  //     })
  //   );
  // }
  const [selectedRow, setselectedRow] = useState("");
  // console.log("selectedRow: ", selectedRow.commission ,selectedRow.mmtc_commission);

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = (data) => {
    setOpen(true);
    setselectedRow(data);
  };
  const [formData, setFormData] = useState({
    commission: "",
    mmtc_commission: "",
  });
  useEffect(() => {
    if (selectedRow) {
      setFormData({
        commission: selectedRow.commission || "",
        mmtc_commission: selectedRow.mmtc_commission || "",
      });
    }
  }, [selectedRow]);
  // console.log("formData: ", formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error if value is valid
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = `/partner/commission_update/${selectedRow._id}`;
      // const url = `${baseUrl}/partner/commission_update/${selectedRow._id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axiosInstance.post(url, formData);
      // await axios.post(url, formData, { headers });
      Swal.fire({
        // text: response.data.message,
        text: "Batuk partners commssion updated successfully",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
      dispatch(batukPartnerApi());
      // toast.success("Batuk partners commssion updated successfully");
      handleClose();
      setFormData({ commission: "", mmtc_commission: "" });
    } catch (error) {
      console.error("Error updating user:", error);
      Swal.fire({
        // text: response.data.message,
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
      // toast.error("Error updating partner data");
      handleClose();
    }
  };
  return (
    <>
      {/* */}
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="BatukPartner"
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            // border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            ID : {selectedRow._id}{" "}
          </Typography>
          <Typography variant="h6" component="h2">
            Email : {selectedRow.PartnerId}{" "}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Commission"
                  name="commission"
                  value={formData.commission}
                  // value={selectedRow.commission}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="mmtc commission"
                  name="mmtc_commission"
                  value={formData.mmtc_commission}
                  // value={selectedRow.mmtc_commission}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ float: "right" }}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  );
}
